// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CONTENT_CHANNELS: '/content/channels',
  CONTENT_CATEGORIES: '/content/categories',
  CONTENT_SHOWS: '/content/shows',
  CONTENT_VIDEOS: '/content/episodes',
  CONTENT_SEQUENCE: '/content/sequence',
  CONTENT_SETTINGS: '/content/settings',
  CONTENT_WEB: '/content/web',
  ADMIN_USERS: '/users',
  SUBSCRIBERS: '/subscribers',
  CONTACTS: '/contact',
  REPORTS_OVERVIEW_VIDEOS: '/reports/overview/episodes',
  REPORTS_LIVE_USERS: '/reports/live-users',
  REPORTS_WATCH_SESSIONS: '/reports/watch/sessions',
  REPORTS_VIDEO_WATCH_SESSIONS: '/reports/episode/sessions',
  REPORTS_APP_SESSIONS: '/reports/app/sessions',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
